import { Button } from "../../../components/button/button.jsx"
import classNames from "classnames";

import styles from "./subscribePage.module.css";
import { Header } from "../../../components/header/header.jsx";

import { Text } from "../../../components/text/text";

export const SubscribePage = () => {

    return (
        <>
            <Header title="Настройки подписки" />
            <div className={styles.subscribes_container}>
                <div className={classNames(styles.subscribe_container, {[styles.active]: true})}>
                    <Text as="div" variant="h2" className={styles.subscribe_title} >Премиум</Text>
                    <div className={styles.subscribe_advantages}>
                        <Text as="div" variant="body" className={styles.subscribe_advantage} >Дополнительная мотивация</Text>
                        <Text as="div" variant="body" className={styles.subscribe_advantage} >Быстрый рост</Text>
                        <Text as="div" variant="body" className={styles.subscribe_advantage} >Ежедневные бонусы</Text>
                    </div>
                    <Text as="div" variant="h1" className={styles.subscribe_price} >{"987"} ₽</Text>
                    <Button text="Выбрать" type="secondary" />
                </div>

                <div className={styles.subscribe_container}>
                    <Text as="div" variant="h2" className={styles.subscribe_title} >Бесплатно</Text>
                    <div className={styles.subscribe_advantages}>
                        <Text as="div" variant="body" className={styles.subscribe_advantage} >Дополнительная мотивация</Text>
                    </div>
                    <Text as="div" variant="h1" className={styles.subscribe_price} >0 ₽</Text>
                    <Button text="Выбрано" type="primary" />
                </div>
            </div>
        </>
    )
}